module.exports = __webpack_public_path__ + "img/consultation2.d23eec75.jpeg";